const config = {
  app: {
    name: process.env.NEXT_PUBLIC_APP_NAME || "",
    url: process.env.NEXT_PUBLIC_APP_URL || "",
    apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || "",
  },
  contact: {
    primaryPhone: "9429691484",
    primaryEmail: "sales@everse.in",
    whatsappNumber: "9429691484",
  },
  service: {
    google: {
      clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || "",
    },
    payu: {
      baseUrl: process.env.NEXT_PUBLIC_PAYU_BASE_URL || "",
      key: process.env.NEXT_PUBLIC_PAYU_KEY || "",
      salt: process.env.PAYU_SALT || "",
    },
  },
};

export default config;
